module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "tab-box weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((['国内', '国际']), function(name, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-item weex-ct weex-div",
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.switchTab(i)
        }
      }
    }, [_c('p', {
      staticClass: "['tab-item-text', i===checkedIndex && 'text-selected'] weex-el weex-text",
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-item-selected-bar weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    ref: "tab-bar",
    staticClass: "tab-item-selected-bar-in weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "tab-item-active weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71dc2b2e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71dc2b2e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-city/tab.vue
// module id = 626
// module chunks = 0 1